export enum ProjectEvents {
  'CREATED_PROJECT' = 'CREATED_PROJECT',
  'EDITED_PROJECT' = 'EDITED_PROJECT',
  'DELETED_PROJECT' = 'DELETED_PROJECT',
  'ARCHIVED_PROJECT' = 'ARCHIVED_PROJECT',
  'RELOAD_PROJECTS' = 'RELOAD_PROJECTS',
}
